import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '@c2fo/liquidity';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';
import queryClient from '@/lib/queryClient';

export type DismissibleKind = paths['/user/dismissibles']['post']['requestBody']['content']['application/json']['kind'];
type DismissiblePostBody = paths['/user/dismissibles']['post']['requestBody']['content']['application/json'];

const useDismissDismissible = () => {
  const showSnackbar = useSnackbar();

  return useMutation({
    mutationKey: ['dismissDismissible'],
    mutationFn: (kind: DismissibleKind) => {
      return apiClient.post(`api/supplier-experience/user/dismissibles`, {
        json: { kind } satisfies DismissiblePostBody,
      });
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ['dismissibles'],
      });

      showSnackbar({ message: 'C2FO Lending Connections information hidden' });
    },
  });
};

export default useDismissDismissible;
